<template>
  <div class="body">
    <img src="../../static/315pxlogo.jpg" style="width:0;height:0">
    <img :src="imgurl" alt="图片邀请" />
    <img src="../../static/315pxlogo.jpg" style="width:0;height:0">
  </div>
</template>

<script>
import { getToken } from "../../../api/common";
import { wxIconUrl} from "../../../utils/common";
import wx from "weixin-jsapi";
export default {
  data() {
    return {
      imgurl: "",
      iconUrl:"",
    };
  },

  components: {},

  computed: {},

  methods: {
    //生成随机串

    async downImage() {
      //调取接口
      const { data } = await getToken();

      // console.log("调取成功的数据", data);
      // console.log(wx);
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.data.app_id, // 必填，公众号的唯一标识
        timestamp: data.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.data.noncestr, // 必填，生成签名的随机串
        signature: data.data.signature, // 必填，签名
        jsApiList: [
          "updateAppMessageShareData",
          "updateTimelineShareData",
          "onMenuShareAppMessage",
        ], // 必填，需要使用的JS接口列表
      });
      //配置自定义分享内容

      wx.ready(function () {
        let config = {
          title:
            "中国国际采矿展，今年观展您还在排队办证？猛戳这里快速完成观众登记！", // 分享标题
          desc: "10月26-29日，北京中国国际展览中心(新馆)，第19届中国国际采矿展将隆重举办，敬请期待！", // 分享描述
          link:
            window.location.href.split("#")[0] +
            "#" +
            window.location.href.split("#")[1],
          type: "link", //分享类型,music、video或link,不填默认为link,
          imgUrl: wxIconUrl(),
        };
        // console.log("执行了分享");
       // console.log(window.location.href.split("#")[0])
       // console.log(window.location.href.split("#")[1])
        
        wx.onMenuShareAppMessage(config); // 微信好友
        wx.onMenuShareTimeline(config); // 微信朋友圈
        wx.onMenuShareQQ(config); // QQ
      });
    },
    //window.location.href.split('#')[0]
  },
  created() {
    document.title =
      "中国国际采矿展，今年观展您还在排队办证？猛戳这里快速完成观众登记！";
    document.documentElement.style.fontSize =
      document.documentElement.clientWidth / 10 + "px"; //动态的设置html的font-size恒等屏幕的1/10
    let path = window.location.href.split("=");
    this.imgurl = decodeURIComponent(path[1]);
    this.downImage();
    this.iconUrl = wxIconUrl()
  },

  //消除app.vue设置的样式
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "min-width:auto");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
};
</script>

<style lang="scss" scoped>
$ue-width: 750; /* 设计稿图的宽度 */
//rem
@function px2rem($px) {
  @return #{$px/$ue-width * 10}rem;
}
.none{
  display: none !important;
}
.body {
  img {
    max-width: 100%;
    width: 100%;
    display: block;
  }
  .img_box {
    width: 315px;
    height: 315px;
    display: none;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
